import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  events: [],
  selectedEvent: null,
  isLoading: false,
  error: null,
};

const eventSlice = createSlice({
  name: "event",
  initialState,
  reducers: {
    isPending: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    eventFail: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },

    // ✅ Fetch all events
    getEventsSuccess: (state, action) => {
      state.events = action.payload;
      state.isLoading = false;
    },

    // ✅ Fetch single event
    getSingleEventSuccess: (state, action) => {
      state.selectedEvent = action.payload;
      state.isLoading = false;
    },

    // ✅ Create event
    createEventSuccess: (state, action) => {
      state.events.push(action.payload);
      state.isLoading = false;
    },

    // ✅ Update event
    updateEventSuccess: (state, action) => {
      const idx = state.events.findIndex((e) => e._id === action.payload._id);
      if (idx >= 0) state.events[idx] = action.payload;
      if (state.selectedEvent?._id === action.payload._id)
        state.selectedEvent = action.payload;
      state.isLoading = false;
    },

    // ✅ Delete event
    deleteEventSuccess: (state, action) => {
      state.events = state.events.filter((e) => e._id !== action.payload);
      if (state.selectedEvent?._id === action.payload)
        state.selectedEvent = null;
      state.isLoading = false;
    },

    // ✅ Add gallery images + extended description
    addGalleryImagesSuccess: (state, action) => {
      const idx = state.events.findIndex((e) => e._id === action.payload._id);
      if (idx >= 0) state.events[idx] = action.payload;
      if (state.selectedEvent?._id === action.payload._id)
        state.selectedEvent = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  isPending,
  eventFail,
  getEventsSuccess,
  getSingleEventSuccess,
  createEventSuccess,
  updateEventSuccess,
  deleteEventSuccess,
  addGalleryImagesSuccess,
} = eventSlice.actions;

export default eventSlice.reducer;
